export type TiledCameraPreviewDomain = [number, number] | null;

export interface TiledCameraSyncGroup {
  publish(source: object, preview: TiledCameraPreviewDomain): void;
  subscribe(source: object, onPreview: (preview: TiledCameraPreviewDomain) => void): () => void;
}

/**
 * Shared camera for a set of TiledTimeSeriesCharts: pass one group to each
 * chart's `cameraSync` prop and an in-progress pan/zoom on any chart previews
 * live on the others, frame-by-frame. Purely imperative — sibling charts apply
 * the previewed domain as a plot-group transform and axis re-tick, so nothing
 * re-renders through React until the gesture settles.
 */
export function createTiledCameraSyncGroup(): TiledCameraSyncGroup {
  const subscribers = new Map<object, (preview: TiledCameraPreviewDomain) => void>();
  return {
    publish(source, preview) {
      for (const [subscriber, onPreview] of subscribers) {
        if (subscriber !== source) onPreview(preview);
      }
    },
    subscribe(source, onPreview) {
      subscribers.set(source, onPreview);
      return () => {
        subscribers.delete(source);
      };
    },
  };
}
